

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcIconModule } from 'mwc/icon';

import { MwcFormItemFeedbackIconComponent } from './mwc-form-item-feedback-icon.component';

@NgModule({
  imports: [CommonModule, MwcIconModule],
  exports: [MwcFormItemFeedbackIconComponent],
  declarations: [MwcFormItemFeedbackIconComponent]
})
export class MwcFormPatchModule {}
